import React from 'react';
import './PosterElement.css';
import { Poster } from '../types/types';


const PosterGridElement: React.FC<Poster> = ({ id, title, description, dataItems }) => {
    return (
        <div className="poster">
            <h2>{title}</h2>
            <p className="poster-description">{description}</p>
            <div className="data-items-list">
                {dataItems.map((item, index) => (
                    <h3 key={index}>{item.title}</h3>
                ))}
            </div>
        </div>
    );
};

export default PosterGridElement; 